<script>import hash from "object-hash";
export let pageType;
export let title;
export let defaultTitle;
export let metaDescription;
export let defaultMetaDescription;
export let metaImage;
export let language;
export let datePublished;
export let dateUpdated;
export let url;
export let siteUrl;
export let artist;
export let artwork;
const schemaOrgWebsite = {
  "@type": "WebSite",
  "@id": `${siteUrl}/#website`,
  url: siteUrl,
  name: defaultTitle,
  description: defaultMetaDescription,
  inLanguage: language
};
const schemaOrgWebPage = {
  "@type": "WebPage",
  "@id": `${url}/#webpage`,
  url,
  name: title,
  isPartOf: {
    "@id": `${siteUrl}/#website`
  },
  primaryImageOfPage: {
    "@id": `${url}/#primaryimage`
  },
  datePublished,
  dateModified: dateUpdated,
  description: metaDescription,
  breadcrumb: {
    "@id": `${url}/#breadcrumb`
  },
  inLanguage: language,
  potentialAction: [
    {
      "@type": "ReadAction",
      target: [url]
    }
  ]
};
const schemaOrgImageObject = {
  "@type": "ImageObject",
  "@id": `${url}/#primaryimage`,
  inLanguage: language,
  url: metaImage?.url ?? "",
  contentUrl: metaImage?.url ?? "",
  caption: metaImage?.caption ?? ""
};
metaImage?.width ?? (schemaOrgImageObject.width = metaImage?.width);
metaImage?.height ?? (schemaOrgImageObject.height = metaImage?.height);
let shemaArtistPerson = null;
let shemaVisualArtwork = null;
let artistEntityHash = null;
if (["artist", "artwork", "person"].includes(pageType)) {
  artistEntityHash = hash({ name: artist.name }, { algorithm: "md5" });
  shemaArtistPerson = {
    "@type": ["Person", "Organization"],
    url: metaImage?.url,
    "@id": `${url}#/schema/person/${artistEntityHash}`,
    name: artist.name,
    image: {
      "@type": "ImageObject",
      "@id": `${url}#personlogo/${artistEntityHash}`,
      inLanguage: language,
      url: artist.image,
      contentUrl: artist.image,
      width: 512,
      height: 512,
      caption: artist.name
    },
    logo: {
      "@id": `${url}#personlogo/${artistEntityHash}`,
      contentUrl: artist.image
    },
    sameAs: artist.sameAs
  };
}
if (pageType === "artwork") {
  shemaVisualArtwork = {
    "@type": "VisualArtwork",
    "@id": `${url}/#/schema/VisualArtwork/${artistEntityHash}`,
    name: artwork.name,
    description: artwork.description,
    image: artwork.image,
    dateCreated: artwork.dateCreated,
    artEdition: artwork.artEdition,
    artMedium: artwork.artMedium,
    artform: artwork.artform,
    artist: {
      "@id": `${url}/#/schema/person/${artistEntityHash}`
    }
  };
}
const schemaOrgArray = [
  schemaOrgWebsite,
  schemaOrgWebPage,
  schemaOrgImageObject,
  ...pageType === "artist" ? [shemaArtistPerson] : [],
  ...pageType === "artwork" ? [shemaArtistPerson, shemaVisualArtwork] : []
];
const schemaOrgObject = {
  "@context": "https://schema.org",
  "@graph": schemaOrgArray
};
let jsonLdString = JSON.stringify(schemaOrgObject);
let jsonLdScript = `
		<script type="application/ld+json">
			${jsonLdString}
		${"<"}/script>
	`;
</script>

<svelte:head>
  <!-- eslint-disable-next-line -->
  {@html jsonLdScript}
</svelte:head>
